import React from 'react';
import {Link} from 'react-router-dom';
import NumberFormat from 'react-number-format';
import './Program.scss'
import verifiedBadge from '../../../images/verified.png';


const ProgramCarbon = (props) => {
   return(
      <div className="col-sm-6 col-md-4 col-lg-3">
         <div className="mb-4">
            <div className="card card-program card-item" style={{background:'none'}}>
               <Link to={`/program/carbon?id=${props.id}`} className="link-absolute"></Link>
               <div className="card-program-image">
                  <img src={props.urlFeaturedImage} className="card-image" alt={props.title}/>
               </div>
               <div className="card-body-blank">
                  <h3 className="card-program-title mt-0 mb-1">{props.title}</h3>
                  <div className="card-program-seller card-text-small mb-1">
                  <i className="fa fa-user"></i> {props.corporateName}</div>
                  <div className="card-program-location card-text-small mb-1">
                  <i className="fa fa-map-marker-alt"></i> {props.province}
                  </div>
                  <span className="card-price text-orange">{props.currencySymbol} <NumberFormat value={props.pricePerYear} displayType={'text'} decimalScale={0}  thousandSeparator={','} decimalSeparator={'.'}/> <small className="card-text-small"> / Ton</small></span> 
               </div>
            </div>
         </div>
      </div>
   
   )
}
   export default ProgramCarbon;